import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const resHouseRegisterSlice = createSlice({
  name: 'resHouseRegister',
  initialState: { resHouseRegister: initialState },
  reducers: {
    resHouseRegisterApi: (state, data) => {
      state.resHouseRegister = data.payload;
    },
  },
});

export const { resHouseRegisterApi } = resHouseRegisterSlice.actions;

export default resHouseRegisterSlice.reducer;
